<div class="modal fade" id="addNewAcademicHoliday" tabindex="-1" aria-labelledby="addNewAcademicHolidayLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="border-0 shadow modal-content rounded-4 academic-holiday-modal">
      <form [formGroup]="form" (ngSubmit)="onSave()">
        <div class="py-5 modal-header px-7">
          <h4 class="modal-title fw-bold text-dark" id="addNewAcademicHolidayLabel">
            วันหยุดราชการ
          </h4>

          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="clearForm()"></button>
        </div>

        <div class="px-10 py-8 modal-body">
          <div class="row g-6">
            <div class="col-md-6">
             
                 <app-select formControlName="year" label="ปีการศึกษา" [options]="yearOptions" [required]="true"
                [searchable]="false" [isDisabled]="isEditMode" [errorMessage]="errors.year ?? ''"
                [error]="errors.year"
                (inputChange)="onYearChange($event)"></app-select>
            </div>

            <div class="col-md-6">
              <app-select formControlName="academicTermId" label="เทอมการศึกษา" [options]="termOptions" bindLabel="name"
                bindValue="id" [required]="true" [searchable]="false" [isDisabled]="isEditMode"
                [errorMessage]="errors.academicTermId ?? ''"
                [error]="errors.academicTermId"></app-select>
            </div>

            <div class="col-md-6">
              <app-input formControlName="name" label="ชื่อวันหยุดราชการ" [required]="true"
                [errorMessage]="errors.name ?? ''"
                [error]="errors.name"></app-input>
            </div>

            <div class="col-md-6">
              <app-datepicker formControlName="holidayDate" label="วันที่หยุดราชการ" [required]="true"
                [errorMessage]="errors.holidayDate ?? ''"
                [error]="errors.holidayDate"></app-datepicker>
            </div>
          </div>
        </div>

        <div class="px-10 pt-2 pb-8 border-0 modal-footer">
          <button type="button" class="btn btn-secondary btn-lg fw-bold me-4" data-bs-dismiss="modal"
            (click)="clearForm()">
            {{ "COMPONENT.CANCEL" | translate }}
          </button>

          <button type="submit" class="text-white btn btn-lg fw-bold me-4 academic-holiday-save-button"
            [disabled]="isSaving">
            {{ "COMPONENT.SAVE" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<app-confirm-dialog
  #saveAcademicHolidayConfirmDialog
  modalId="saveAcademicHolidayConfirm"
  icon="warning"
  title="ยืนยันการบันทึกข้อมูล"
  message="คุณต้องการบันทึกข้อมูลนี้ใช่หรือไม่ ?"
  cancelText="ยกเลิก"
  confirmText="ยืนยัน"
  [isProcessing]="isSaving"
  (confirmed)="onConfirmSave()"
></app-confirm-dialog>
